module.exports = __webpack_public_path__ + "static/media/templateQualificationsImberaBr.d9650d6b.xlsx";